function handleControlVariantDomMutations(header) {
  header.classList.add("control");
  header.classList.remove("opacity-0");
}

function handleDefaultVariantDomMutations(header) {
  header.classList.remove("control");
  header.classList.add("variant");
}

export default function(gb) {
  const header = document.querySelector("[data-controller='header']");
  if (header) header.classList.remove("opacity-0");
  if (!gb) return;

  const feature = gb.evalFeature("homepage-header");

  // only on the homepage
  if (!["/", "/nl"].includes(window.pageProperties?.relative_url)) return;
  if (!["nl", "test_lang"].includes(window.pageProperties?.locale)) return;

  const elementsToTrack = [
    { selector: "wistia-player", event: "gb_home_demo_video_click" },
    { selector: "[data-slice='feature-overview'] a[data-wistia-id='n4cn8ovnx5']", event: "gb_home_fo_demo_video_click" },
    { selector: "#main-content header a[href*='/aanmelden']", event: "gb_home_signup_link_click" },
    { selector: "#main-content header a[href*='/over-ons']", event: "gb_home_about_link_click" },
  ];
  window.trackElementClicks(elementsToTrack, feature);

  if (feature.on && feature.value === 1) {
    handleDefaultVariantDomMutations(header);
  } else {
    handleControlVariantDomMutations(header);
  }
}